module.exports = __webpack_public_path__ + "static/media/text-height.cf6ead32.svg";